// Ikone iz jednog kompleta (kao IC u staroj aplikaciji, vlasnik 8. 10. 2026.): umjesto tipkanih znakova ✓ ← × ‹ ›.
// Veličina prati tekst (1em, klasa .ic u styles.css), boja je boja teksta.
import type { ReactNode } from 'react';

const sv = (d: ReactNode) => (
  <svg
    className="ic"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {d}
  </svg>
);

export const IC = {
  check: sv(<path d="M5 12.5l4.2 4.2L19 7" />),
  chev: sv(<path d="M9 5.5l6.5 6.5L9 18.5" />),
  back: sv(<path d="M15 5.5L8.5 12l6.5 6.5" />),
  x: sv(<path d="M6.5 6.5l11 11M17.5 6.5l-11 11" />),
};
